import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'isNumber',
    standalone: false
})
export class IsNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return Number.isFinite(value);
  }

}
